import React from "react";
import { Card, Avatar, Row, Col } from "antd";
import { Container } from "react-bootstrap";
const { Meta } = Card;

const Internships = () => {
  return (
    <Container>
      <Row gutter={16} style={{ marginTop: 20 }}>
        <Col style={{ marginTop: 20 }} l xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card
            bordered={false}
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              background: "linear-gradient(145deg, #06174a, #071c58)",
              borderWidth: 0,
              borderRadius: 0,
              boxShadow: "7px 7px 14px #061542, -7px -7px 14px #081f62"
            }}
            cover={
              <img
                alt="example"
                src={require("./sc.png")}
                style={{ width: "100%", resize: "unset", height: 200 }}
              />
            }
            className="card">
            <Meta
              title={
                <span
                  style={{
                    color: "yellow",
                    fontFamily: "Ubuntu Mono",
                    fontWeight: "bold",
                    textShadow: "1px 1px 18px white"
                  }}>
                  Front-end Developer
                </span>
              }
              description={
                <span
                  style={{
                    color: "white",
                    fontFamily: "Ubuntu Mono",
                    opacity: 0.7
                  }}>
                  July 2020 - Present
                </span>
              }
            />
          </Card>
        </Col>
        <Col style={{ marginTop: 20 }} xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card
            bordered={false}
            style={{
              width: "100%",

              marginLeft: "auto",
              marginRight: "auto",
              background: "linear-gradient(145deg, #06174a, #071c58)",
              borderWidth: 0,
              borderRadius: 0,
              boxShadow: "7px 7px 14px #061542, -7px -7px 14px #081f62"
            }}
            cover={
              <img
                alt="example"
                src={require("./collegedunia.jpg")}
                style={{ width: "100%", resize: "unset", height: 200 }}
              />
            }
            className="card">
            <Meta
              title={
                <span
                  style={{
                    color: "yellow",
                    fontFamily: "Ubuntu Mono",
                    fontWeight: "bold",
                    textShadow: "1px 1px 18px white"
                  }}>
                  Content Writer
                </span>
              }
              description={
                <span
                  style={{
                    color: "white",
                    fontFamily: "Ubuntu Mono",
                    opacity: 0.7
                  }}>
                  Nov 2019 - Present
                </span>
              }
            />
          </Card>
        </Col>
        <Col style={{ marginTop: 20 }} l xs={24} sm={12} md={8} lg={8} xl={8}>
          <Card
            bordered={false}
            style={{
              width: "100%",

              marginLeft: "auto",
              marginRight: "auto",
              background: "linear-gradient(145deg, #06174a, #071c58)",
              borderWidth: 0,
              borderRadius: 0,
              boxShadow: "7px 7px 14px #061542, -7px -7px 14px #081f62"
            }}
            cover={
              <img
                alt="example"
                src={require("./ls.jpg")}
                style={{ width: "100%", resize: "unset", height: 200 }}
              />
            }
            className="card">
            <Meta
              title={
                <span
                  style={{
                    color: "yellow",
                    fontFamily: "Ubuntu Mono",
                    fontWeight: "bold",
                    textShadow: "1px 1px 18px white"
                  }}>
                  Writer
                </span>
              }
              description={
                <span
                  style={{
                    color: "white",
                    fontFamily: "Ubuntu Mono",
                    opacity: 0.7
                  }}>
                  Mar 2020 - Apr 2020
                </span>
              }
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Internships;
